export default __webpack_public_path__ + "static/media/KADET.443b530a.png";